"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setLoadingImage() {
    return (state, actions, { tabName = state.ui.currentTabName, loadingImage }) => {
        return Object.assign({}, state, { tabs: Object.assign({}, state.tabs, { [tabName]: Object.assign({}, state.tabs[tabName], { loadingImage }) }) });
    };
}
exports.setLoadingImage = setLoadingImage;
//# sourceMappingURL=set-loading-image.js.map